import { jsxs as a, jsx as t } from "react/jsx-runtime";
import C, { useState as v } from "react";
import { APIProvider as I, useMapsLibrary as V } from "../../../node_modules/.pnpm/@vis.gl_react-google-maps@1.7.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@vis.gl/react-google-maps/dist/index.modern.js";
import { cn as n } from "../../../lib/utils.js";
import { useDesignSystemConfig as w } from "../../../providers/DesignSystemProvider.js";
function R({
  onAddressSelect: d,
  error: e,
  initialValue: i,
  label: r = "Property Address",
  placeholder: u = "Start typing address...",
  required: m = !1,
  className: y
}) {
  const o = V("places"), [A, g] = v(i || ""), [, k] = v(null), P = C.useCallback(
    (c) => {
      if (!c || !o) return;
      const p = new o.Autocomplete(c, {
        componentRestrictions: { country: "us" },
        types: ["address"],
        fields: ["address_components", "formatted_address"]
      });
      p.addListener("place_changed", () => {
        const f = p.getPlace();
        if (!f.address_components) return;
        let x = "", b = "", h = "", _ = "";
        f.address_components.forEach((s) => {
          const l = s.types;
          l.includes("street_number") && (x = s.long_name + " "), l.includes("route") && (x += s.long_name), l.includes("locality") && (b = s.long_name), l.includes("administrative_area_level_1") && (h = s.short_name), l.includes("postal_code") && (_ = s.long_name);
        });
        const N = {
          formatted: f.formatted_address || "",
          street: x.trim(),
          city: b,
          state: h,
          zip: _
        };
        g(N.formatted), d(N);
      }), k(p);
    },
    [o, d]
  );
  return o ? /* @__PURE__ */ a("div", { className: n("space-y-1.5", y), children: [
    r && /* @__PURE__ */ a("label", { className: "block text-sm font-medium text-text-primary", children: [
      r,
      " ",
      m && /* @__PURE__ */ t("span", { className: "text-lpr-red", children: "*" })
    ] }),
    /* @__PURE__ */ t(
      "input",
      {
        ref: P,
        type: "text",
        value: A,
        onChange: (c) => g(c.target.value),
        required: m,
        className: n(
          "w-full px-4 py-2 rounded-lg border bg-bg-surface text-text-primary",
          "placeholder:text-text-secondary/50",
          "focus:outline-none focus:ring-2 focus:ring-lpr-teal focus:border-transparent",
          "transition-colors duration-200",
          e ? "border-lpr-red focus:ring-lpr-red" : "border-border-color hover:border-lpr-teal/50"
        ),
        placeholder: u
      }
    ),
    e && /* @__PURE__ */ t("p", { className: "text-sm text-lpr-red", children: e })
  ] }) : /* @__PURE__ */ a("div", { className: n("space-y-1.5", y), children: [
    r && /* @__PURE__ */ a("label", { className: "block text-sm font-medium text-text-primary", children: [
      r,
      " ",
      m && /* @__PURE__ */ t("span", { className: "text-lpr-red", children: "*" })
    ] }),
    /* @__PURE__ */ t("div", { className: "h-10 rounded-lg bg-bg-muted animate-pulse" })
  ] });
}
function K({
  apiKey: d,
  ...e
}) {
  const { googlePlacesApiKey: i } = w(), r = d || i || "";
  return r ? /* @__PURE__ */ t(I, { apiKey: r, children: /* @__PURE__ */ t(R, { ...e }) }) : /* @__PURE__ */ a("div", { className: n("space-y-1.5", e.className), children: [
    e.label !== void 0 ? e.label && /* @__PURE__ */ a("label", { className: "block text-sm font-medium text-text-primary", children: [
      e.label,
      " ",
      e.required && /* @__PURE__ */ t("span", { className: "text-lpr-red", children: "*" })
    ] }) : /* @__PURE__ */ a("label", { className: "block text-sm font-medium text-text-primary", children: [
      "Property Address",
      " ",
      e.required && /* @__PURE__ */ t("span", { className: "text-lpr-red", children: "*" })
    ] }),
    /* @__PURE__ */ t(
      "input",
      {
        type: "text",
        defaultValue: e.initialValue,
        onChange: (u) => e.onAddressSelect({
          formatted: u.target.value,
          street: "",
          city: "",
          state: "",
          zip: ""
        }),
        required: e.required,
        className: n(
          "w-full px-4 py-2 rounded-lg border bg-bg-surface text-text-primary",
          "placeholder:text-text-secondary/50",
          "focus:outline-none focus:ring-2 focus:ring-lpr-teal focus:border-transparent",
          "transition-colors duration-200",
          e.error ? "border-lpr-red focus:ring-lpr-red" : "border-border-color hover:border-lpr-teal/50"
        ),
        placeholder: e.placeholder || "Enter property address..."
      }
    ),
    e.error && /* @__PURE__ */ t("p", { className: "text-sm text-lpr-red", children: e.error })
  ] });
}
export {
  K as AddressAutocomplete
};
//# sourceMappingURL=AddressAutocomplete.js.map
